import React, { FC, ComponentProps } from 'react'
import { zeroAddress } from 'viem'

import FormatCrypto from './FormatCrypto'
import FormatCurrency from './FormatCurrency'
import { FormatCurrencyProps } from 'types/Currency'

type Props = ComponentProps<typeof FormatCrypto> & FormatCurrencyProps

const FormatUSDCurrency: FC<Props> = ({
  amount,
  address = zeroAddress,
  maximumFractionDigits,
  logoHeight = 8,
  logoVariant = 'default',
  textStyle,
  css,
  decimals,
}) => {
  if (typeof amount === 'bigint') {
    amount = amount.toString()
  }
  return <FormatCurrency css={css} style={textStyle} amount={amount} />
}

export default FormatUSDCurrency
